(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MM-Info-Block"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const MQ = window.matchMedia('(max-width: 768px)');

        function syncDropdowns(isMobile) {
            document.querySelectorAll('.mm-info-block-item').forEach(function (el, index) {
                if (isMobile) {
                    if (index === 0) {
                        el.setAttribute('open', '');
                    } else {
                        el.removeAttribute('open');
                    }
                } else {
                    el.setAttribute('open', '');
                }
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { syncDropdowns(MQ.matches); });
        } else {
            syncDropdowns(MQ.matches);
        }

        MQ.addEventListener('change', function (e) { syncDropdowns(e.matches); });
    })();

  } catch(e) { console.error(e); }
})();
})();
